import { z } from 'zod';
import { EventTypeSchema, DayTypeSchema } from './calendar';

/** Where the forecast number came from — full audit trail for debugging. */
export const ProvenanceSchema = z.object({
  historical_window_start: z.string(),
  historical_window_end: z.string(),
  historical_sample_size: z.number().int().nonnegative(), // rows considered
  historical_baseline_avg: z.number(),
  historical_baseline_p85: z.number().nullable(),
  baseline_event_type: EventTypeSchema, // type the baseline came from
  fallback_used: z.boolean(), // true if we fell back to NORMAL avg
  monthly_multiplier: z.number(),
  event_multiplier: z.number(),
  config_versions: z.record(z.number().int()), // {monthly:1, event:1, ...}
  uph_eff: z.number().positive(), // weighted units per hour
});
export type Provenance = z.infer<typeof ProvenanceSchema>;

/** Confidence band — derived from sample dispersion. */
export const ConfidenceSchema = z.object({
  p85: z.number().nullable(),
  p50: z.number().nullable(),
  sample_size: z.number().int().nonnegative(),
  is_low_confidence: z.boolean(), // true when n < 5
});
export type Confidence = z.infer<typeof ConfidenceSchema>;

export const ForecastResultSchema = z.object({
  id: z.string(),
  warehouse_id: z.string(),
  customer_id: z.string(),
  date: z.string(), // target date YYYY-MM-DD
  event_type: EventTypeSchema,
  day_type: DayTypeSchema,
  forecast_qty: z.number().int().nonnegative(),
  wlu_per_order_minutes: z.number().nonnegative(),
  total_workload_minutes: z.number().nonnegative(),
  total_workload_hours: z.number().nonnegative(),
  provenance: ProvenanceSchema,
  confidence: ConfidenceSchema,
  version: z.number().int().positive(),
  is_current: z.boolean(),
  generated_at: z.string(),
  generated_by: z.string(),
});
export type ForecastResult = z.infer<typeof ForecastResultSchema>;
